import { connect } from 'react-redux';
import { isUuid } from '../../../js/app/react/validators';
import View from './HomePurchaseWorkflowView';
import { WORKFLOW_ID } from './HomePurchaseWorkflowConstants';
import {
  reloadAdvizrApplication,
  endOfWorkflowsRedirectTo,
} from '../AdvWorkflow/AdvWorkflowHelpers';
import { shouldSkipSummarySelector } from '../AdvWorkflow/AdvWorkflowSelector';
import { getGoalPageName } from '../../FinancialPlanOPL/Goals/utils/getGoalPageName';
import { GoalTypeDTO } from '../../FinancialPlanOPL/types/goalsDTO';
import { nullableGoalIdSelector } from './HomePurchaseWorkflowSelector';

const mapStateToProps = (state, ownProps) => ({
  workflowId: WORKFLOW_ID,
  shouldSkipSummary: shouldSkipSummarySelector(state, ownProps),
  goalId: nullableGoalIdSelector(state, { ...ownProps, workflowId: WORKFLOW_ID }),
});

const mapDispatchToProps = () => ({
  outputFunction: (clientId, goalId) => () => {
    const { ADV } = window;
    reloadAdvizrApplication(true, false, () => {
      const currentClient = ADV.util.getCurrentClient(ADV.data);

      const outputRoute = currentClient.ComponentName || getGoalPageName(GoalTypeDTO.HomePurchase);

      if (!isUuid(goalId)) {
        throw new Error("'payload.viewData.Goal.Id' must be an uuid.");
      }

      const params = {
        clientId,
        goalId,
      };

      endOfWorkflowsRedirectTo(outputRoute, params);
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
